import {Bar} from 'vue-chartjs/legacy'
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from 'chart.js'
import {mapState} from 'vuex'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  components: {
    Bar
  },

  computed: {
    ...mapState('statistics', ['graphsData', 'isLoadingGraphs']),

    chartData() {
      const sorted = this.graphsData.filter((n) => n.saleAmount > 0)
        .sort((a, b) => a.saleAmount - b.saleAmount)

      const labels = sorted.map(i => i.saleAmount.toFixed(2))
      const data = sorted.map(i => i.count)

      return {
        labels,
        datasets: [
          {
            backgroundColor: '#4A90E2',
            data,
            borderRadius: {
              topLeft: 6,
              topRight: 6
            },
            borderSkipped: 'bottom'
          }
        ]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            grace: '10%'
          }
        }
      }
    }
  }
}
